// THESE VARIABLES MUST BE EXPORTED FROM THIS FILE (as opposed to @/src/services/Sardine)
// because the bundler is being weird again and making them undefined otherwise

/**
 * unique identifier for an element that shall be tracked by Sardine
 * @see {@link https://docs.sardine.ai/guides/integration/riskSDK/mobileSDKs/reactNativeExpo#usage}
 * @see {@link https://docs.sardine.ai/guides/integration/riskSDK/webSDKs/ReactJS#call-get-session-key-function-to-check-current-session-key-optional}
 */
export type SardineId = string

/** @see {@link SardineId} */
export const sardineIdKey = 'sardine-id'

type DefaultSardineExports = typeof import('@/src/services/Sardine')
type WebSardineExports = typeof import('@/src/services/Sardine/index.web')

true satisfies DefaultSardineExports extends WebSardineExports
  ? WebSardineExports extends DefaultSardineExports
    ? true
    : false
  : false
